<ng-container *ngIf="notes$ | async; else loader">
  <div class="notes-container">
    <mojo-collection [overflowHidden]="false">

      <mat-accordion class="expantion-transition">
        <mat-expansion-panel
          class="mat-expantion-tpanel"
          [expanded]="true"
          [disabled]="isNotesPage || sideDrawerConfiguration"
          (opened)="isPanelOpen = true"
          (closed)="isPanelOpen = false"
        >
          <mat-expansion-panel-header class="main-container-expands">
            <div
              class="header"
              [ngClass]="{'padding-b': (isPanelOpen && !sideDrawerConfiguration), 'padding-info-side-drawer': sideDrawerConfiguration, 'padding-corners': !sideDrawerConfiguration}"
              data-cy="notes-container-header"
            >

              <div
                *ngIf="isExpandible"
                (click)="toggleCard()"
                class="expand-button"
                color="light-natural"
              >
                <mat-icon
                  *ngIf="!isPanelOpen"
                  class="rotate-arrow color-arrow-expandable font-s-icon mat-icon-right"
                >
                  arrow_drop_up
                </mat-icon>
                <mat-icon
                  *ngIf="isPanelOpen"
                  class="color-arrow-expandable font-s-icon mat-icon-top"
                >
                  arrow_drop_down
                </mat-icon>
              </div>

              <a
                (click)="$event.stopPropagation()"
                *ngIf="(currentRoute$ | async) !== 'notes'"
                routerLink="notes"
                class="notes-link"
              >Notes</a>
              <mojo-collection-header
                *ngIf="(currentRoute$ | async) === 'notes' && isPanelOpen"
                text="Notes"
                [colorTitle]="true"
              ></mojo-collection-header>

              <span
                class="buttons-container single-tab-notes"
                *ngIf="isPanelOpen"
              >
                <a
                  class="add-note-link"
                  (click)="openNoteModal($event)"
                >+ Add note</a>
                <button
                  *ngIf="!sideDrawerConfiguration"
                  (click)="toggleSearchInputVisibility($event)"
                  class="notes-filters search-phrases single-tab-notes"
                  data-cy="notes-filters-phrases"
                  mat-icon-button
                >
                  <mat-icon class="filters">search</mat-icon>
                </button>
                <button
                  *ngIf="!setDefaultNotesPageFilter"
                  [matBadge]="numberOfActiveFilters"
                  [matBadgeHidden]="numberOfActiveFilters === '2'"
                  [matMenuTriggerFor]="notesFiltersMenu"
                  (click)="$event.stopPropagation()"
                  class="notes-filters single-tab-notes"
                  data-cy="notes-filters-menu-button"
                  mat-icon-button
                  matBadgeColor="accent"
                  matBadgeSize="small"
                >
                  <mat-icon class="filters">filter_list</mat-icon>
                </button>
              </span>
            </div>
          </mat-expansion-panel-header>
          <ng-container
            [ngTemplateOutlet]="isSingleTabsNotesFeatureExtensionEnabled ? single: multi"
          >

          </ng-container>
        </mat-expansion-panel>
      </mat-accordion>

      <ng-template #multi>
        <div class="notes-filters multi-tab-margin">
          <mat-tab-group
            (selectedTabChange)="selectedTabChange($event)"
            class="tabs"
            disablePagination="true"
          >
            <mat-tab
              *ngIf="!loggedInUserIsHiringManager && showRecruiterTab"
              label="@RECRUITING TEAM"
            >
              <mojo-notes-keyword-search
                [notesType]="subject"
                data-cy="mojo-notes-keyword-search"
                *ngIf="isSearchInputVisible"
              >
              </mojo-notes-keyword-search>
              <mojo-notes-list
                [fullpage]="(currentRoute$ | async) === 'notes'"
                [isForRecruitingTeamTab]="true"
                [notes]="notes$ | async"
                [subjectId]="subjectId"
                [subjectType]="subject"
                data-cy="recruiting-team-notes"
              >
              </mojo-notes-list>
            </mat-tab>
            <mat-tab
              label="@HIRING TEAM"
              *ngIf="showHiringManagerTab"
            >
              <div
                *ngIf="showAnonymizationWarning"
                class="anonymization-notification"
                data-cy="notes-container-anonymization-warning"
              >
                ✋ Anonymization is on, communicate accordingly.
              </div>
              <mojo-notes-keyword-search
                [notesType]="secondarySubject"
                data-cy="mojo-notes-keyword-search"
                *ngIf="isSearchInputVisible"
              >
              </mojo-notes-keyword-search>
              <mojo-notes-list
                [fullpage]="(currentRoute$ | async) === 'notes'"
                [isForHiringTeamTab]="true"
                [notes]="notesHiringManager$ | async"
                [subjectId]="subjectId"
                [subjectType]="secondarySubject"
                data-cy="hiring-team-notes"
              >
              </mojo-notes-list>
            </mat-tab>
          </mat-tab-group>
        </div>
      </ng-template>

      <ng-template #single>
        <mojo-notes-keyword-search
          [notesType]="subject"
          data-cy="mojo-notes-keyword-search"
          *ngIf="isSearchInputVisible"
        >
        </mojo-notes-keyword-search>
        <mojo-notes-list
          [sideDrawerConfiguration]="sideDrawerConfiguration"
          [fullpage]="(currentRoute$ | async) === 'notes'"
          [notes]="notes$ | async"
          [subjectId]="currentRouteId$ | async"
          [subjectType]="subject"
        >
        </mojo-notes-list>
      </ng-template>
    </mojo-collection>
  </div>
  <mat-menu
    #notesFiltersMenu="matMenu"
    class="global-menu"
    xPosition="before"
  >
    <button
      (click)="setNotesFilters(true, true)"
      [class.selected]="shouldSetAllNotesAsChecked()"
      class="notes-filters-item"
      data-cy="all-notes-filter"
      mat-menu-item
    >
      All Notes
    </button>
    <button
      (click)="setNotesFilters(true, false)"
      [class.selected]="shouldSetUserNotesAsChecked()"
      class="notes-filters-item"
      data-cy="people-notes-filter"
      mat-menu-item
    >
      People Notes
    </button>
    <button
      (click)="setNotesFilters(false, true)"
      [class.selected]="shouldSetSystemNotesAsChecked()"
      class="notes-filters-item"
      data-cy="system-notes-filter"
      mat-menu-item
    >
      System Notes
    </button>
  </mat-menu>
</ng-container>

<ng-template #loader>
  <mojo-loader></mojo-loader>
</ng-template>
